import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogMaterialModule } from './dialog-material.module';
import { SvgComponent } from '../../core/components/svg-component/svg-component.component';
import { DialogConfigInterface } from '../../core/interfaces';

@Component({
    selector: 'app-dialog',
    imports: [CommonModule, DialogMaterialModule, SvgComponent],
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogConfigInterface
  ) {
    this.dialogRef.disableClose = this.data.disableClose || false;
  }

  public close(): void {
    this.dialogRef.close(false);
  }
}
